<h2 mat-dialog-title>Ange verifieringskod</h2>
<mat-dialog-content>
    <p>För att logga in behöver du ange verifikationskoden som skickades till den e-post du försökt logga in med.</p>
    <mat-form-field>
        <mat-label>Kod</mat-label>
        <input
            matInput
            type="text"
            autocomplete="off"
            [(ngModel)]="verificationCode"
            (keydown.enter)="login()"
            name="loginVerification" />
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()">Avbryt</button>
    <button mat-raised-button (click)="login()">OK</button>
</mat-dialog-actions>

